module.exports = __webpack_public_path__ + "static/img/index_five_image.7fa8246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_five_image.png
// module id = vjjV
// module chunks = 1